import { Paper, Stack, Typography } from "@mui/material";
import SmartActionItem from "./SmartActionItem";
import type { SmartAction } from "../../../types/types";

interface SmartActionsPanelProps {
  actions: SmartAction[];
}

export default function SmartActionsPanel({ actions }: SmartActionsPanelProps) {
  return (
    <Paper sx={{ borderRadius: "16px", p: 2, boxShadow: 0, height: "100%" }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          color: "#64748b",
          mb: 2,
        }}
      >
        Smart Actions
      </Typography>

      <Stack spacing={1}>
        {actions.map((action, index) => (
          <SmartActionItem key={index} action={action} />
        ))}
      </Stack>
    </Paper>
  );
}
